import { render, staticRenderFns } from "./JeecgOrderTicketModal.vue?vue&type=template&id=1c960cda&scoped=true"
import script from "./JeecgOrderTicketModal.vue?vue&type=script&lang=js"
export * from "./JeecgOrderTicketModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c960cda",
  null
  
)

export default component.exports